import { IconProps } from "../../utils/global-types/global-types";

const MaintenanceIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 28 28"
    className={className}
    {...rest}
  >
    <g fill="currentColor">
      <path d="M0.168 4.255C0.317 3.634 1.091 3.413 1.546 3.867L4.568 6.891H6.889V4.569L3.871 1.553C3.419 1.101 3.637 0.328 4.255 0.176C5.683-0.173 7.998-0.121 9.788 1.669C11.355 3.235 11.858 5.573 11.122 7.643L20.357 16.878C22.427 16.142 24.765 16.645 26.331 18.212C28.076 19.956 28.179 22.296 27.83 23.747C27.681 24.368 26.907 24.589 26.453 24.134L23.431 21.111H21.109V23.432L24.126 26.448C24.578 26.9 24.36 27.674 23.742 27.825C22.315 28.174 20.001 28.123 18.21 26.333C16.644 24.767 16.14 22.429 16.877 20.359L7.641 11.124C5.571 11.86 3.234 11.357 1.667 9.79C-0.078 8.046-0.181 5.706 0.168 4.255Z" />
      <path d="M14 19.802L7 26.8C5.6 28.201 3.43 28.375 1.838 27.322L8.161 20.999C8.481 20.679 8.481 20.16 8.161 19.839C7.84 19.519 7.321 19.519 7 19.839L0.678 26.162C-0.375 24.57-0.201 22.4 1.2 21L8.198 14.001L14 19.802Z" />
      <path d="M27.914 2.347L25.593 6.988C25.473 7.229 25.242 7.395 24.975 7.434L21.186 7.974L17.48 11.68L16.32 10.52L20.025 6.815L20.566 3.025C20.605 2.758 20.771 2.527 21.012 2.407L25.653 0.086C25.968-0.071 26.35-0.009 26.599 0.24L27.76 1.401C28.009 1.65 28.071 2.032 27.914 2.347Z" />
    </g>
  </svg>
);

export default MaintenanceIcon;
